import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../manage.css";

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [roles, setRoles] = useState([]);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    role: "",
  });

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const [userResponse, rolesResponse] = await Promise.all([
          axios.get(`https://api.arkiva.gov.al/api/users/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),

          axios.get("https://api.arkiva.gov.al/api/roles", {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        const user = userResponse.data;

        setFormData({
          firstName: user.firstName || "",
          lastName: user.lastName || "",
          email: user.email || "",
          phone: user.phone || "",
          password: "",
          role: user.role?._id || user.role || "",
        });

        setRoles(rolesResponse.data);
      } catch (error) {
        console.error("Error fetching user:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "Emri nuk mund të jetë bosh!";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Mbiemri nuk mund të jetë bosh!";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email nuk mund të jetë bosh!";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Numri i telefonit nuk mund të jetë bosh!";
    }

    if (!formData.role) {
      newErrors.role = "Zgjidhni një rol!";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      const dataToSend = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        role: formData.role,
      };

      if (formData.password.trim()) {
        dataToSend.password = formData.password;
      }

      await axios.put(
        `https://api.arkiva.gov.al/api/users/update/${id}`,
        dataToSend,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      navigate("/manage/users");
    } catch (error) {
      console.error("Error updating user:", error);

      alert(
        error.response?.data?.message ||
          "Ndodhi një gabim gjatë përditësimit të përdoruesit.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/manage/user");
  };

  return (
    <div className="edit-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

      <div className="return">
        <button onClick={handleCancel}>
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      </div>

      <p>Edito Përdorues</p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="firstName">Emri</label>

          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
          />

          {errors.firstName && (
            <small className="error">{errors.firstName}</small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="lastName">Mbiemri</label>

          <input
            type="text"
            id="lastName"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />

          {errors.lastName && (
            <small className="error">{errors.lastName}</small>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>

          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />

          {errors.email && <small className="error">{errors.email}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="phone">Telefon</label>

          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />

          {errors.phone && <small className="error">{errors.phone}</small>}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password i ri</label>

          <input
            type="password"
            id="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="Lëreni bosh për të mos e ndryshuar"
          />
        </div>

        <div className="form-group">
          <label htmlFor="role">Roli</label>

          <select
            id="role"
            name="role"
            value={formData.role}
            onChange={handleChange}
          >
            <option value="">Zgjidh rolin</option>

            {roles.map((role) => (
              <option key={role._id} value={role._id}>
                {role.name}
              </option>
            ))}
          </select>

          {errors.role && <small className="error">{errors.role}</small>}
        </div>

        <div className="edit-actions">
          <button type="submit" className="save">
            Ruaj ndryshimet
          </button>

          <button type="button" className="cancel" onClick={handleCancel}>
            Anullo
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditUser;
